import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

import {
  FormInputField,
  IValidationService,
  ValidatorConfig,
} from '@fmnts/declarative-forms';

import { e164PhoneFormat } from './validators/phone.validator';

const enum PhoneValidatorNames {
  E164PhoneFormat = 'e164PhoneFormat',
}

@Injectable({
  providedIn: 'root',
})
export class PhoneValidationBuilder implements IValidationService {
  buildValidator(
    validator: ValidatorConfig,
    field: FormInputField,
  ): ValidatorFn[] {
    switch (validator.name) {
      case PhoneValidatorNames.E164PhoneFormat:
        return [e164PhoneFormat()];
    }

    return [];
  }
}
